import * as _ from 'lodash';
import { IPaginationService } from '../interfaces/IPaginationService';
import { IRow } from '../interfaces/IRow';

export class PaginationService implements IPaginationService{
	itemsPerPage: number;
  page: number = 0;
  totalRowsCount: number;

  transformRows(rows: Array<IRow>): Array<IRow>{
  	if(this.isActive() == false){
      return rows;
    }
    if(!this.totalRowsCount){
      this.totalRowsCount = rows.length;
    } 
    return rows;
  }

  isActive(){
    return this.itemsPerPage > 0;
  }

  setItemsPerPage(pageSize: any){
    this.itemsPerPage = Number.parseInt(pageSize, 10);
    this.page = this.page == 0 ? 1 : this.page;
  }

  setTotalRowsCount(totalRowsCount: number){
    this.totalRowsCount = totalRowsCount;
  }

  getStartIndex(): number{
    return (this.page-1) * this.itemsPerPage;
  }

  getEndIndex() : number{
    return Math.min(this.getStartIndex()+this.itemsPerPage,this.totalRowsCount);
  }

  nextPage(): void{
    if(this.hasNextPage()){
      this.page++;
    }
  }

  previousPage(): void{
    if(this.hasPreviousPage()){
      this.page --;
    }
  }

  hasPreviousPage(): boolean {
    return this.page > 1;
  }

  hasNextPage(): boolean {
    var totalPages = Math.ceil(this.totalRowsCount / this.itemsPerPage);
    return this.page < totalPages;
  }
}